export default __webpack_public_path__ + "static/media/gallery-img-3.8036ae4a.jpg";